import React, { createContext, useContext, useState, useEffect } from 'react';
import { db } from '../config/firebase';
import { doc, getDoc, collection, getDocs, query, orderBy } from 'firebase/firestore';

const ContentContext = createContext();

export const useContent = () => {
  const context = useContext(ContentContext);
  if (!context) {
    // Fallback to default content if context not available
    return {
      homeContent: null,
      aboutContent: null,
      contactInfo: null,
      seoSettings: null,
      links: null,
      packages: [],
      loading: false
    };
  }
  return context;
};

export const ContentProvider = ({ children }) => {
  const [homeContent, setHomeContent] = useState(null);
  const [aboutContent, setAboutContent] = useState(null);
  const [contactInfo, setContactInfo] = useState(null);
  const [seoSettings, setSeoSettings] = useState(null);
  const [links, setLinks] = useState(null);
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAllContent();
  }, []);

  const loadAllContent = async () => {
    try {
      setLoading(true);

      // Load all content in parallel
      const [homeDoc, aboutDoc, contactDoc, seoDoc, linksDoc, packagesSnapshot] = await Promise.all([
        getDoc(doc(db, 'content', 'homeContent')),
        getDoc(doc(db, 'content', 'aboutContent')),
        getDoc(doc(db, 'content', 'contactInfo')),
        getDoc(doc(db, 'content', 'seoSettings')),
        getDoc(doc(db, 'links', 'download')),
        getDocs(query(collection(db, 'packages'), orderBy('createdAt', 'desc')))
      ]);

      if (homeDoc.exists()) setHomeContent(homeDoc.data());
      if (aboutDoc.exists()) setAboutContent(aboutDoc.data());
      if (contactDoc.exists()) setContactInfo(contactDoc.data());
      if (seoDoc.exists()) setSeoSettings(seoDoc.data());
      if (linksDoc.exists()) setLinks(linksDoc.data());
      
      const packagesData = [];
      packagesSnapshot.forEach((doc) => {
        packagesData.push({ id: doc.id, ...doc.data() });
      });
      setPackages(packagesData);
    } catch (err) {
      console.error('Load content error:', err);
    } finally {
      setLoading(false);
    }
  };

  const value = {
    homeContent,
    aboutContent,
    contactInfo,
    seoSettings,
    links,
    packages,
    loading,
    refresh: loadAllContent
  };

  return (
    <ContentContext.Provider value={value}>
      {children}
    </ContentContext.Provider>
  );
};
